<template>
  <div class="popular-directions public-section">
    <div v-if="oneLocationEditable || hasFastOrder" class="popular-directions-title" :class="{ 'fast-order': hasFastOrder }">
      <component :is="titleTag" class="flex flex-align-items-center">
        <vz-icon url="/svg/vz-stars.svg" no-masked-icon variant="primary" size="54" class="mr-10" />
        {{ title }}
      </component>
      <city-autocomplete v-if="oneLocationEditable" large :model-value="oneLocation.guid" @update:modelValue="changeOneLocation" label="" />
      <div
        v-if="hasFastOrder"
        class="popular-directions-fast-order"
      >
        <vz-button
          large
          variant="primary"
          class="flex flex-center"
          @click="showManageHelp"
        >
          Быстрый заказ
        </vz-button>
        <vz-manager-help-modal />
      </div>
    </div>
    <component v-else :is="titleTag" class="color-primary text-center">{{ title }}</component>
    <div class="popular-directions-wrapper mt-30">
      <div class="popular-directions-wrapper-item">
        <client-only>
          <city-autocomplete
            large
            label-public-style
            v-if="twoLocationEditable"
            :model-value="oneLocation.guid"
            @update:modelValue="changeOneLocation"
            class="my-30"
            label="Отправка"
          />
          <template #fallback>
            <vz-skeleton height="48" class="mb-30" style="margin-top: 59px" />
          </template>
        </client-only>
        <popular-direction
          is-dispatch
          :short-links="shortLinks"
          :location="oneLocation"
          :is-two-location-editable="twoLocationEditable"
        />
      </div>
      <div class="popular-directions-wrapper-item">
        <client-only>
          <city-autocomplete
            large
            label-public-style
            v-if="twoLocationEditable"
            :model-value="twoLocation.guid"
            @update:modelValue="changeTwoLocation"
            class="my-30"
            label="Прибытие"
          />
          <template #fallback>
            <vz-skeleton height="48" class="mb-30" style="margin-top: 59px" />
          </template>
        </client-only>
        <popular-direction          
          :short-links="shortLinks"
          :location="twoLocationEditable ? twoLocation : oneLocation"
          :is-two-location-editable="twoLocationEditable"
        />
      </div>
    </div>
    <div class="popular-directions-description mt-30">
      *При заказе через личный кабинет и параметрах груза: длина – 0.2 м, ширина – 0.2 м, высота – 0.2 м и вес – 2.5 кг
    </div>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { usePopularDirectionsStore } from '~/stores/popular-directions'
import VzManagerHelpModal from '~/components/modals/vz-manager-help-modal.vue'
import PopularDirection from '~/components/public/popular-directions/popular-direction.vue'
import CityAutocomplete from '~/components/autocomplete/city-autocomplete.vue';
import VzIcon from '~/components/ui-kit/vz-icon.vue';
import VzButton from "~/components/ui-kit/vz-button.vue";

// компонент работает в 3 режимах: отображения, с одним и двумя управляющими элементами
const props = defineProps({
  oneLocationEditable: {
    type: Boolean,
    default: false
  },
  twoLocationEditable: {
    type: Boolean,
    default: false
  },
  hasFastOrder: {
    type: Boolean,
    default: false
  },
  shortLinks: {
    type: Boolean,
    default: false   
  },
  title: {
    type: String, 
    default: 'Популярные маршруты'
  },
  titleH3: {
    type: Boolean,
    default: false
  }
})

const { $showDialog } = useNuxtApp()
const { oneLocation, twoLocation } = storeToRefs(usePopularDirectionsStore())
const { changeOneLocation, changeTwoLocation } = usePopularDirectionsStore()

const titleTag = computed(() => {
  return props.titleH3 ? 'h3' : 'h2'
})

function showManageHelp() {
  $showDialog({name: 'manager-help'})
}
</script>
